import React from 'react';
import { Typography } from '@mui/material';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { PatientDocument, PatientDocumentType, PatientStaticDocument, PatientUploadedMedicalDocument, customMedicalDocumentUploadReasonLabel } from '@uplift/api';
import { documentsMapping } from '../molecules/Modals/patient-chart-review-modal/components/PatientStaticDocument';
import { BaseActivityItem } from './BaseActivityItem';
import { useUserQuery } from '@uplift/queries';


export const StaticDocumentActivityItem: React.FC<{
  document: PatientStaticDocument;
  onClick?: () => void;
}> = (props) => {
  return (
    <BaseActivityItem
      onClick={props.onClick}
      chip={<Typography>acknowledged</Typography>}
      title={documentsMapping[props.document.documentKey].title}
      icon={InsertDriveFileOutlined}
      rightContent={<Typography variant="body2" color="textPrimary">by UpLift</Typography>}
      children={props.children}
    />
  );
};


export const UploadedDocumentActivityItem: React.VFC<{
  document: PatientUploadedMedicalDocument;
  onClick?: () => void;
}> = (props) => {
  const { data: provider } = useUserQuery(props.document.providerId, { suspense: true });

  const providerName = React.useMemo(() => {
    if (props.document.uploadedBy === 'provider') {
      return `${provider?.firstName?.[0]}. ${provider?.lastName}`;
    }

    return props.document.uploadedBy;
  }, [ provider, props.document ]);

  return (
    <BaseActivityItem
      onClick={props.onClick}
      chip={<Typography>uploaded</Typography>}
      title={customMedicalDocumentUploadReasonLabel[props.document.reasonForUpload] ?? props.document.reasonForUpload}
      icon={InsertDriveFileOutlined}
      rightContent={<Typography variant="body2" color="textPrimary">by {providerName}</Typography>}
    >
      <Typography color="textSecondary" component="span">
        <strong style={{ fontWeight: 500 }}>Details</strong>: {props.document.additionalDetails}
      </Typography>
    </BaseActivityItem>
  );
};


export const DocumentActivityItem: React.VFC<{
  document: PatientDocument;
  onClick?: () => void;
}> = ({ document, ...props }) => {
  switch (document.type) {
    case PatientDocumentType.static:
      return (
        <StaticDocumentActivityItem
          document={document}
          {...props}
        />
      );
    case PatientDocumentType.medicalRecord:
      return (
        <UploadedDocumentActivityItem
          document={document}
          {...props}
        />
      );
  }

  return null;
};
